import React from 'react';
import { translate } from 'react-i18next';
import { Button, Pagination, Table } from 'semantic-ui-react';

class TableWithPaginationComponent extends React.Component {
  state = { activePage: 1, confirmVisible: false };
  handlePaginationChange = (e, { activePage }) => this.setState({ activePage });
  toggleConfirm = () =>
    this.setState((prevState) => ({
      confirmVisible: !prevState.confirmVisible,
    }));
  render() {
    const {
      headers,
      data,
      showActionButtons,
      handleEditClick,
      handleRemoveClick,
      t,
    } = this.props;
    return (
      <Table compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>ID</Table.HeaderCell>
            {headers.map((header, key) => (
              <Table.HeaderCell key={key}>{header.label}</Table.HeaderCell>
            ))}
            {showActionButtons ? (
              <Table.HeaderCell colSpan="2" textAlign="center">
                {t('room:actionText')}
              </Table.HeaderCell>
            ) : undefined}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data.map((row, key) => (
            <Table.Row key={key}>
              <Table.Cell collapsing>{key + 1}</Table.Cell>
              {headers.map((header, k) => (
                <Table.Cell key={k}>{row[header.key]}</Table.Cell>
              ))}
              {/* <Confirm
                open={this.state.confirmVisible}
                header={t('common:warningHeaderText')}
                content={t('common:warningText')}
                cancelButton={t('common:noText')}
                confirmButton={t('common:yesText')}
                onCancel={this.toggleConfirm}
                onConfirm={() => {
                  handleRemoveClick(row);
                  this.toggleConfirm();
                }}
              /> */}
              {showActionButtons ? (
                <React.Fragment>
                  <Table.Cell collapsing>
                    <Button
                      circular
                      icon="edit"
                      basic
                      color="yellow"
                      onClick={() => handleEditClick(row)}
                    />
                  </Table.Cell>
                  <Table.Cell collapsing>
                    <Button
                      circular
                      icon="remove"
                      basic
                      color="red"
                      onClick={() => handleRemoveClick(row)}
                    />
                  </Table.Cell>
                </React.Fragment>
              ) : undefined}
            </Table.Row>
          ))}
        </Table.Body>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan={headers.length + 3}>
              <Pagination
                activePage={this.state.activePage}
                onPageChange={this.handlePaginationChange}
                totalPages={1}
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    );
  }
}
export const TableWithPagination = translate('translations')(
  TableWithPaginationComponent
);



// WEBPACK FOOTER //
// ./src/components/TableView/TableWithPagination.js